// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"499":"d1772c460234919cd001","547":"81d038ca4911b5b6642a","640":"aaaad60856c4e0c28e40","881":"46aa04f78d5eb08a120f"}[chunkId] + ".css";
};